import { Immutable } from "immer";
import React from "react";
import { useStaticURL } from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

import type { HomeAdvert as Value } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import bannerStyles from "../../styles/composable/banner.module.scss";

type IProps = Immutable<{
    value: Value | null;
}>;

/**
 * Faithful JSX transcription of the legacy sealy
 * ``components/adverts/home_advert.html`` (#33285). The block is a value-less
 * StaticBlock: the serialized value is an empty object (or null on the
 * standalone template path) and is ignored.
 */
export const HomeAdvert = (_props: IProps): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <section
            className={concatClassNames([
                bannerStyles.banner,
                bannerStyles.bannerShade,
            ])}
            id="pptech"
        >
            <picture className={bannerStyles.bannerFigure}>
                <source
                    srcSet={`${staticURL}img/advert/banner-pptech.png`}
                    media="(max-width: 768px)"
                />
                <img
                    className="img-responsive"
                    srcSet={`${staticURL}img/advert/banner-pptech-full.png`}
                    alt="Tempur Sealy Bed"
                    loading="lazy"
                    decoding="async"
                />
            </picture>

            <div className={bannerStyles.bannerContent}>
                <img
                    className={bannerStyles.bannerImgTitle}
                    src={`${staticURL}img/advert/banner-pptech-title.png`}
                    alt="Tempur Sealy Bed"
                    loading="lazy"
                    decoding="async"
                />
                <p
                    className={concatClassNames([
                        bannerStyles.bannerCopy,
                        bannerStyles.bannerCopyHome,
                    ])}
                >
                    {t`Each part of your body needs different kinds of support. Our exclusive Posturepedic Technology targets these zones for deep support and comfort. Now available in every Sealy Line.`}
                </p>
                <p>
                    <a href="/why-posturepedic" title={t`Why Posturepedic`}>
                        {t`Learn More`}
                    </a>
                </p>
                {/* Static Wistia popover markup transcribed verbatim; the global widgets scanner binds it on load -- no JS here. */}
                <span
                    className="wistia_embed wistia_async_621gumqrmz popover=true popoverAnimateThumbnail=true popoverContent=link"
                    style={{ display: "inline" }}
                >
                    <svg className={bannerStyles.bannerCtaIcon}>
                        <title>{t`Play Video Icon`}</title>
                        <use xlinkHref="#icon-play" />
                    </svg>
                    <a
                        className={bannerStyles.bannerCta}
                        href="#"
                        title={t`Play Video`}
                    >
                        {t`See How it Supports You`}
                    </a>
                </span>
            </div>
        </section>
    );
};
